import React from "react";

const LanguageMenu = ({ options, onSelect }) => {
  // useEffect(() => {
  //   options?.forEach((option) => {
  //     const img = new Image();
  //     img.src = option?.flag;
  //   });
  // }, [options]);

  return (
    <div className="w-[160px] shadow-language-menu-shadow bg-pure-white border border-secondary-gray rounded-[8px] flex flex-col">
      {options &&
        options?.length > 0 &&
        options?.map((option, index) => {
          const FlagIcon = option?.flag;
          return (
            <button
              key={option?.value}
              onClick={() => onSelect(option)}
              className={`shrink-0 p-[12px] w-full text-left hover:bg-secondary-gray/80 transition-colors duration-200 ${
                index !== options?.length - 1 &&
                "border-b-[1px] border-secondary-gray"
              } ${index === 0 && "rounded-t-[8px]"} ${
                index === options?.length - 1 && "rounded-b-[8px]"
              } flex items-center gap-[6px]`}
            >
              {/* <img
              src={option?.flag}
              alt={option?.label}
              className="w-[24px] h-[24px] shrink-0"
              loading="eager"
              fetchPriority="high"
              decoding="async"
            /> */}
              <FlagIcon className="w-[24px] h-[24px] shrink-0 rounded-full" />
              <span className="shrink-0 font-medium text-[14px] text-primary-black">
                {option?.label}
              </span>
            </button>
          );
        })}
    </div>
  );
};

export default LanguageMenu;
